























































import { Component, Vue } from 'vue-property-decorator';
import EntityEditPage from '@/views/shared/EntityEditPage.vue';
import ListPicker from '@/components/ListPicker.vue';
@Component({
  components: {
    EntityEditPage,
    ListPicker
  }
})
export default class NumerazioniEditPage extends Vue {
  public datarow: any;

  constructor() {
    super();
  }
}
